import { LocationState, Path } from 'history';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const isModifiedEvent = (event: React.MouseEvent) =>
  !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

export const useNavigateSafely = () => {
  const navigate = useNavigate();

  const buildNavigateSafely = (path: Path, state?: LocationState) => (event: React.MouseEvent) => {
    if (
      !event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !isModifiedEvent(event) // ignore clicks with modifier keys
    ) {
      event.preventDefault();
      navigate(path, { state });
    }
  };

  return useCallback(buildNavigateSafely, [navigate]);
};
